import { translate } from "@classdojo/web/utils/translate";
import combineActionHandlers from "@web-monorepo/infra/combineActionHandlers";
import createAction from "@web-monorepo/infra/createAction";
import createActionCreator from "@web-monorepo/infra/createActionCreator";
import createReducer from "@web-monorepo/infra/createReducer";
import { PodInstallFunction } from "@web-monorepo/shared/podInfra";
import icon from "./assets/logo.svg";
import { DISPLAY_CLOSE } from "src/pods/realtime/data/pairing";
import { AppMetadata } from "src/pods/toolkitData/components/EditableSetup";

export const appMetadataNoise = (): AppMetadata => ({
  href: "noise",
  title: translate("dojo.toolkit:apps.noise_meter"),
  backgroundColor: "dt_content_plus",
  icon,
});

type State = {
  gain: number;
  microphonePermissionErrorName: string;
  showSensitivityInput?: boolean;
};

const initialState: State = {
  gain: 0,
  microphonePermissionErrorName: "NotAllowedError",
};

export type NoiseState = {
  noise: State;
};

type Payload = { gain: number };

export const SEND_NOISE = createAction("SEND_NOISE");
export const RECEIVE_NOISE = createAction("RECEIVE_NOISE");
export const SEND_MICROPHONE_PERMISSION_ERROR = createAction("SEND_MICROPHONE_PERMISSION_ERROR");
export const RECEIVE_MICROPHONE_PERMISSION_ERROR = createAction("RECEIVE_MICROPHONE_PERMISSION_ERROR");

export const sendNoise = createActionCreator(SEND_NOISE, (payload: Payload) => payload);

// can pass null to clear the error
export const sendMicrophonePermissionError = createActionCreator(SEND_MICROPHONE_PERMISSION_ERROR, (errorName) => ({
  errorName,
}));

export const sendNoiseHandler = createReducer(SEND_NOISE, (payload: Payload) => (state: NoiseState) => ({
  ...state,
  ...payload,
}));

export const receiveNoiseHandler = createReducer(RECEIVE_NOISE, (payload: Payload) => (state: NoiseState) => ({
  ...state,
  ...payload,
}));

const receiveMicrophonePermissionHandler = createReducer(
  RECEIVE_MICROPHONE_PERMISSION_ERROR,
  ({ errorName }: { errorName: string }) =>
    (state: State): State => ({ ...state, microphonePermissionErrorName: errorName }),
);

const resetMicrophonePermissionHandler = createReducer(
  DISPLAY_CLOSE,
  () =>
    (state: State): State => ({ ...state, microphonePermissionErrorName: "NotAllowedError" }),
);

export const selectGain = (state: NoiseState) => state[STATE_KEY].gain;
export const selectShowSensitivityInput = (state: NoiseState) => state[STATE_KEY].showSensitivityInput;
export const selectMicrophonePermissionErrorName = (state: NoiseState) =>
  state[STATE_KEY].microphonePermissionErrorName;

const STATE_KEY = "noise";

const reducer = combineActionHandlers(initialState, [
  receiveNoiseHandler,
  sendNoiseHandler,
  receiveMicrophonePermissionHandler,
  resetMicrophonePermissionHandler,
]);

const install: PodInstallFunction = (installReducer) => {
  installReducer(STATE_KEY, reducer);
};

export default install;
